module.exports = __webpack_public_path__ + "static/media/v2.8805fce.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experiment6/v2.mp4
// module id = Cmgf
// module chunks = 0